export const DEFAULT_PIPELINE = {
  id: void 0,
  errors: void 0,
  title: "",
  description: "",
  stages: [{ stage: 0, rules: [], match: "EITHER" }],
  source: "",
  created_at: "",
  modified_at: "",
  _scope: "DEFAULT",
  has_deprecated_functions: false
};
